import { Container } from './Reporting.styles';

const Reporting = () => {
  return <Container>Coming Soon</Container>;
};

export { Reporting };
